var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.109 16.1093C37.5877 -5.36952 72.4117 -5.3698 93.8908 16.1087C115.37 37.5878 115.37 72.4122 93.8908 93.8913C72.4117 115.37 37.5877 115.37 16.109 93.8907C-5.36968 72.4119 -5.36968 37.5881 16.109 16.1093ZM75.5061 34.4939C77.6016 36.5894 77.6527 39.9551 75.6594 42.1126L75.5061 42.2721L62.7782 55L75.5061 67.7279C77.654 69.8758 77.654 73.3582 75.5061 75.5061C73.4106 77.6016 70.0449 77.6527 67.8874 75.6594L67.7279 75.5061L55 62.7782L42.2721 75.5061C40.1242 77.654 36.6418 77.654 34.4939 75.5061C32.3984 73.4106 32.3473 70.0449 34.3406 67.8874L34.4939 67.7279L47.2218 55L34.4939 42.2721C32.346 40.1242 32.346 36.6418 34.4939 34.4939C36.5894 32.3984 39.9551 32.3473 42.1126 34.3406L42.2721 34.4939L55 47.2218L67.7279 34.4939C69.8758 32.346 73.3582 32.346 75.5061 34.4939Z",
    fill: "#F1C10A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e2487d5a.svg";
export { ForwardRef as ReactComponent };